import React, {useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import BatchUploadFileSearch from './BatchUploadHome/BatchUploadFileSearch'
import BatchUploadViewResults from './BatchUploadHome/BatchUploadViewResults'
import BatchUploadRecordSwipes from './BatchUploadHome/BatchUploadRecordSwipes'
import NotFound from '../../../../../pages/NotFound'
import ErrorBoundary from '../../../../../components/ErrorBoundary'
import {Box, Divider, Typography} from '@material-ui/core'

// using hook API
const useStyles = makeStyles(() => ({
    boundaryBox: {
        display: 'flex',
        flexDirection: 'column',
        margin: '15px 0',
        fontSize: '0.825rem',
        overflowX: 'hidden',
    },
}))

const BatchUploadHome = props => {
    const classes = useStyles()

    const {eventoccurrence, detectChange, handleClose} = props
    const [finalInvalidSwipeIds, setFinalInvalidSwipeIds] = useState([])
    const [nextStep, setnextStep] = useState('Batch Upload Home')
    const [batchSwipeArray, setbatchSwipeArray] = useState([])
    const [removeDuplicates, setRemoveDuplicates] = useState(false)
    const [missingHeaderFile, setMissingHeaderFile] = useState([])

    const {
        occurTitle,
        isEmployed,
        isEnrolled,
        duplicateAllow,
        duplicateTimeout,
    } = eventoccurrence

    const studentsevent = isEnrolled === 'Y' ? 'Students Only' : ''
    const employeeevemt = isEmployed === 'Y' ? 'Employees Only' : ''
    const studentemployeeevent =
        studentsevent && employeeevemt ? 'Students & Employees Only' : ''

    const allowDuplicateDescr =
        duplicateAllow === 'A'
            ? 'Allow Duplicate Swipes'
            : duplicateTimeout > 0
            ? 'Deny Duplicates within ' + duplicateTimeout + ' minutes'
            : 'Deny Duplicate Swipes'

    let component = null

    switch (nextStep) {
        case 'Batch Upload Home':
            component = (
                <BatchUploadFileSearch
                    setbatchSwipeArray={setbatchSwipeArray}
                    callbackfunction={setnextStep}
                    removeDuplicates={removeDuplicates}
                    setRemoveDuplicates={setRemoveDuplicates}
                    setMissingHeaderFile={setMissingHeaderFile}
                    detectChange={detectChange}
                />
            )
            break
        case 'Batch Upload Review Results':
            component = (
                <BatchUploadViewResults
                    callbackfunction={setnextStep}
                    eventoccurrence={eventoccurrence}
                    batchSwipeArray={batchSwipeArray}
                    removeDuplicates={removeDuplicates}
                    setFinalInvalidSwipeIds={setFinalInvalidSwipeIds}
                    missingHeaderFiles={missingHeaderFile}
                />
            )
            break
        case 'Batch Upload Record Swipes':
            component = (
                <BatchUploadRecordSwipes
                    callbackfunction={setnextStep}
                    eventoccurrence={eventoccurrence}
                    batchSwipeArray={finalInvalidSwipeIds}
                    handleClose={handleClose}
                />
            )
            break
        default:
            component = <NotFound />
    }
    return (
        <>
            <Box className={classes.boundaryBox}>
                <Typography align="left" variant="h6">
                    {occurTitle}
                </Typography>
                <Typography
                    align="left"
                    variant="body2"
                    style={{color: '#000000', fontWeight: 400}}
                >
                    {studentemployeeevent ||
                        studentsevent ||
                        employeeevemt ||
                        'Open to Everyone at UNT'}
                    {', '}
                    {allowDuplicateDescr}
                </Typography>
                <Divider style={{height: '2px', margin: '15px 0 10px 0'}} />
            </Box>
            <ErrorBoundary>{component}</ErrorBoundary>
        </>
    )
}

export default BatchUploadHome
